import * as z from "zod";
import { defineIntegrationSettings } from "../define-settings";

export const growaveSettings = defineIntegrationSettings({
  fields: {
    clientId: z.string().trim().min(1, "Growave client ID is required."),
  },
  secrets: {
    clientSecret: z
      .string()
      .trim()
      .min(1, "Growave client secret is required."),
  },
  connectOnly: {},
  computed: {},
});
